export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Terms & Conditions', href: '/terms' },
  { label: 'Cancellation Policy', href: '/cancellation' },
  { label: 'Refund & Cancellation', href: '/refund' },
];

export const FORM = {
  selectTitle: 'Select Product Name',
  selectHint:
    'Search for your product name or select from the list. If the product you are looking for cannot be found, enter the model number below.',
  regions: ['USA, Canada'],
  detailsTitle: 'Please Enter your Details',
  fullNameLabel: 'Full name',
  fullNamePlaceholder: 'Enter your full name',
  findLink: 'Where to find your product name?',
  findText: 'The product name is located on the front or top of your product. Location may vary.',
  findTip:
    'Look for a label near the control panel or under the scanner lid. It usually shows a short model code.',
  types: ['Inkjet', 'Laser'],
  cta: 'Click here to Download Setup',
};

export const DOWNLOAD = {
  banner: 'Downloading Printer Drivers, Please wait!',
  title: 'Downloading Drivers',
  image: '/images/printer-error.webp',
  downloadComplete: 'Download Complete C0000022',
  installFailed: 'Driver installation has failed due to fatal error C0000022',
};

export const ERROR_PAGE = {
  image: '/images/printer-error.webp',
  heading: '2 Issues Found.',
  issues: ['Printer Spooler Service Not Running', 'Network Port Not Set Correctly'],
  code: 'Error X0007E4',
  contactLine: 'Contact Chat Support to resolve this problem:',
  note:
    'Note: Do not attempt to retry the installation as it can damage the printer and void the product warranty.',
  cta: 'Chat Now',
};

export const HERO = {
  kicker: 'Follow the steps below to get your printer ready in a few minutes.',
  title: 'Setup your Printer',
  image: '/images/printer-hero.webp',
  cards: [
    { tone: 'red', icon: 'printer', title: 'Print Setup', text: 'Wireless & USB' },
    { tone: 'amber', icon: 'download', title: 'Driver Recommended', text: 'Download' },
    { tone: 'green', icon: 'help', title: 'Frequently Asked', text: 'Questions' },
  ],
};

export const STRIP_ITEMS = [
  { icon: 'printer', title: 'Instant Printer Setup', text: 'Guided step-by-step help' },
  { icon: 'wifi', title: 'Wi-Fi, USB & Cloud Support', text: 'Connect the way you prefer' },
  { icon: 'headset', title: '24/7 Technical Assistance', text: 'Real people, real answers' },
  { icon: 'refresh', title: 'Driver & Firmware Updates', text: 'Always run the latest build' },
  { icon: 'tools', title: 'Paper Jam & Print Repair', text: 'Fix common issues quickly' },
];

export const INTRO = {
  image: '/images/printer-jam.webp',
  titleDark: 'New!',
  titleRed: 'Unravel Your Print Obstacles',
  body:
    'A printer should be simple. When it stops responding, prints blank pages, or drops off your network, the fix is usually small but hard to find. Our team walks you through setup, drivers, and everyday errors so your printer works the first time and keeps working after that.',
};

export const SERVICES = {
  titleDark: 'Services We',
  titleRed: 'Provide',
  items: [
    {
      icon: 'printer',
      title: 'Printer Setup',
      text: 'Unbox, install, and connect your printer to a computer or network without guesswork.',
    },
    {
      icon: 'scanner',
      title: 'Scanner & Copier',
      text: 'Get scanning, copying, and scan-to-email working again on Windows and Mac.',
    },
    {
      icon: 'wifi',
      title: 'Wi-Fi Printing',
      text: 'Fix dropped connections, wrong network settings, and offline printer errors.',
    },
    {
      icon: 'tools',
      title: 'Paper Jam Repair',
      text: 'Clear jams safely, correct feed problems, and restore clean, streak-free pages.',
    },
  ],
};

export const PRINT_ANYWHERE = {
  titleDark: 'Print',
  titleRed: 'Anywhere and Anytime',
  subtitle: 'Print from your phone, laptop, or desk.',
  image: '/images/printer-desk.webp',
  paragraphs: [
    'Modern printers do far more than paper and ink. With the right setup you can send a document from your phone on the way home, scan a receipt straight into email, and share one printer across the whole house or office.',
    'We help you switch on mobile printing, connect cloud services, and set the defaults that save paper and toner. Once it is configured properly, it simply works in the background.',
  ],
  note:
    'Not sure which option fits your printer? Our technicians check your model and network first, then set up only what you actually need.',
  linkText: 'See supported printer models',
  cta: 'Get Started Now',
};

export const MINI_FEATURES = [
  { icon: 'mobile', title: 'Mobile Printing', text: 'Send jobs from any phone or tablet.' },
  { icon: 'cloud', title: 'Cloud Print', text: 'Print from anywhere with an account.' },
  { icon: 'wifi', title: 'Wi-Fi Direct', text: 'Connect without a router nearby.' },
  { icon: 'pages', title: 'Duplex Printing', text: 'Automatic two-sided pages.' },
  { icon: 'mail', title: 'Scan to Email', text: 'Send scans straight to an inbox.' },
  { icon: 'lock', title: 'Secure Release', text: 'Hold jobs until you are at the tray.' },
];

export const PAYMENTS = {
  image: '/images/laptop-pay.webp',
  titleDark: 'Secure & Flexible',
  titleRed: 'Payment Options',
  body:
    'Choose a one-time repair or an ongoing plan, whichever suits you. Every payment runs through an encrypted gateway, and you receive a clear invoice by email before anything is charged.',
  cta: 'Explore the Plans',
};

export const CLASS_LEADING = {
  title: 'Class-Leading Elements',
  items: [
    {
      icon: 'diagnostic',
      title: 'Printer and Device Diagnostics',
      text: 'We test the printer, cable, and computer together so the real cause is found instead of guessed.',
    },
    {
      icon: 'wifi',
      title: 'Network Setup Support',
      text: 'Static addresses, guest networks, and firewall rules configured so the printer stays visible.',
    },
    {
      icon: 'cloud',
      title: 'Advanced Remote Printing',
      text: 'Send documents from outside your home or office and collect them when you arrive.',
    },
    {
      icon: 'refresh',
      title: 'Driver & Firmware Upgrades',
      text: 'Correct driver versions installed cleanly, with older conflicting software removed first.',
    },
    {
      icon: 'lock',
      title: 'Secure Print Release',
      text: 'Confidential documents stay in the queue until the right person is standing at the printer.',
    },
    {
      icon: 'shield',
      title: 'Extended Support Coverage',
      text: 'Ongoing help for setup changes, new devices, and problems that appear months later.',
    },
  ],
};

export const COMPATIBILITY = {
  title: 'Compatibility Details',
  items: [
    { title: 'Windows', text: 'Windows 11, 10, 8.1 and 7, both 32-bit and 64-bit builds.' },
    { title: 'macOS', text: 'macOS Sequoia through Catalina, on Apple silicon and Intel.' },
    { title: 'Mobile & Tablet', text: 'Android, iPhone, and iPad using AirPrint or the printer app.' },
  ],
};

export const SUPPORT_BANNER = {
  title: '24/7 Professional Help',
  subtitle: 'Support When You Need It',
  image: '/images/support-desk.webp',
  paragraphs: [
    'Printer problems rarely wait for office hours. A report due in the morning, a boarding pass at midnight, a jammed tray before school — our technicians are available around the clock, every day of the year.',
    'Open the chat window and describe what you see on screen. We stay with you until the printer is working, and we tell you honestly if a repair is not worth the cost.',
  ],
  cta: 'Chat With Us',
};

export const WHY_CHOOSE = {
  titleDark: 'Why',
  titleRed: 'Choose Us?',
  body:
    'We have spent years fixing the problems that manuals skip. That experience means fewer questions, faster answers, and repairs that hold. You speak to a trained technician, not a script, and you always know the cost before we begin.',
  cta: 'Chat With a Technician',
  cards: [
    {
      icon: 'clock',
      title: 'Fast Response Time',
      text: 'Most requests are answered within minutes, day or night.',
    },
    {
      icon: 'badge',
      title: 'Certified Technicians',
      text: 'Trained specialists who work on printers every single day.',
    },
    {
      icon: 'tag',
      title: 'Transparent Pricing',
      text: 'A clear quote up front, with no charges added afterwards.',
    },
    {
      icon: 'shield',
      title: 'No Fix, No Fee',
      text: 'If we cannot solve the problem, you do not pay for the attempt.',
    },
  ],
};

export const FOOTER = {
  aboutTitle: 'Trusted and Professional',
  aboutText:
    'Independent printer setup and repair support for home and small business users.',
  linksTitle: 'Useful Links',
  links: [
    { label: 'About Us', href: '/about' },
    { label: 'Refund & Cancellation', href: '/refund' },
  ],
  policiesTitle: 'Policies',
  policies: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms & Conditions', href: '/terms' },
    { label: 'Cancellation Policy', href: '/cancellation' },
    { label: 'Refund & Cancellation', href: '/refund' },
  ],
  contactTitle: 'Get in Touch',
  contactText:
    'Our support team is available around the clock through live chat. Start a conversation and a technician will reply straight away.',
  contactCta: 'Start Live Chat',
  disclaimer:
    'We are an independent service provider and are not affiliated with any printer manufacturer. Brand names and logos are the property of their respective owners.',
};
